import React, { useContext, useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../contexts/AppContext';
import { languages, getTranslation } from '../config/translations';

export default function Header({ color = '#64798A' }) {
    const navigate = useNavigate();
    const { textAndAudio, setTextAndAudio, bgMusicVolume, setBgMusicVolume, dbType, setDbType } = useContext(AppContext);
    const [menuOpen, setMenuOpen] = useState(false);
    const [languageOpen, setLanguageOpen] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState('it'); // Default to Italian
    const [confirmHomeOpen, setConfirmHomeOpen] = useState(false);
    const location = window.location.pathname;
    const menuRef = useRef(null);
    const toggleRef = useRef(null);

    const t = getTranslation(selectedLanguage);

    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
        setLanguageOpen(false); // Close language dropdown when main menu toggles
    };

    const toggleLanguageDropdown = () => {
        setLanguageOpen(prev => !prev);
    };

    const handleLanguageSelect = (langCode) => {
        setSelectedLanguage(langCode);
        setLanguageOpen(false);
        // Here you can add logic to update language context or localStorage
        localStorage.setItem('selectedLanguage', langCode);
    };

    const handleLogout = () => {
        localStorage.clear();
        navigate('/');
    };

    const handleHomeClick = () => {

        if (location.includes('/exercise')) {
            setConfirmHomeOpen(true);
        }
        /*
        else if(location.includes('/login')) {
            navigate('/');
        }
         */
        else {
            navigate('/pages/exePage');
        }
    };

    const confirmHomeYes = () => {
        setConfirmHomeOpen(false);
        navigate('/pages/exePage');
    };

    const confirmHomeNo = () => {
        setConfirmHomeOpen(false);
    };

    useEffect(() => {
        // Load saved language on component mount
        const savedLanguage = localStorage.getItem('selectedLanguage');
        if (savedLanguage && languages.find(lang => lang.code === savedLanguage)) {
            setSelectedLanguage(savedLanguage);
        }
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                menuRef.current &&
                !menuRef.current.contains(e.target) &&
                toggleRef.current &&
                !toggleRef.current.contains(e.target)
            ) {
                setMenuOpen(false);
                setLanguageOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const currentLanguage = languages.find(lang => lang.code === selectedLanguage);

    return (
        <header style={{ ...styles.header, backgroundColor: color }}>
            <div style={styles.icon} onClick={handleHomeClick} ref={toggleRef}>
                <img src="/assets/icons/home.png" alt="Home" style={styles.img} />
            </div>

            <div style={styles.title}>{t.title}</div>
            <div style={styles.icon} onClick={toggleMenu} ref={toggleRef}>
                <img src="/assets/icons/hamburger.png" alt="Menu" style={styles.img} />
            </div>

            {menuOpen && (
                <div style={styles.dropdown} ref={menuRef}>
                    {/* Mode Toggle */}
                    <div style={styles.toggleContainer}>
                        <span style={styles.toggleLabel}>{t.mode}</span>
                        <div style={styles.toggleSwitch} onClick={() => setTextAndAudio(prev => !prev)}>
                            <div
                                style={{
                                    ...styles.toggleSlider,
                                    backgroundColor: color,
                                    transform: textAndAudio ? 'translateX(0)' : 'translateX(100%)'
                                }}
                            />
                            <span style={{
                                ...styles.toggleOption,
                                ...styles.toggleLeft,
                                color: textAndAudio ? '#fff' : '#333'
                            }}>
                                {t.textAudio}
                            </span>
                            <span style={{
                                ...styles.toggleOption,
                                ...styles.toggleRight,
                                color: !textAndAudio ? '#fff' : '#333'
                            }}>
                                {t.onlyAudio}
                            </span>
                        </div>
                    </div>

                    {/* Database Toggle */}
                    

                    {/* Language Selection */}
                    <div style={styles.languageContainer}>
                        <span style={styles.toggleLabel}>{t.language}</span>
                        <div style={styles.languageSelector} onClick={toggleLanguageDropdown}>
                            <div style={styles.selectedLanguage}>
                                <span style={styles.flag}>{currentLanguage.flag}</span>
                                <span style={styles.languageName}>{currentLanguage.name}</span>
                                <span style={{
                                    ...styles.arrow,
                                    transform: languageOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                                }}>▼</span>
                            </div>
                            {languageOpen && (
                                <div style={styles.languageDropdown}>
                                    {languages.map((lang) => (
                                        <div
                                            key={lang.code}
                                            style={{
                                                ...styles.languageOption,
                                                backgroundColor: selectedLanguage === lang.code ? '#f0f0f0' : 'transparent'
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleLanguageSelect(lang.code);
                                            }}
                                        >
                                            <span style={styles.flag}>{lang.flag}</span>
                                            <span>{lang.name}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Volume Slider */}
                    <div style={styles.volumeContainer} onClick={(e) => e.stopPropagation()}>
                        <span style={styles.toggleLabel}>{t.volume} {Math.round(bgMusicVolume * 100)}%</span>
                        <input
                            type="range"
                            min="0"
                            max="1"
                            step="0.01"
                            value={bgMusicVolume}
                            onInput={(e) => {
                                const newVol = parseFloat(e.target.value);
                                console.log("Header: Setting volume to", newVol);
                                setBgMusicVolume(newVol);
                            }}
                            style={styles.volumeSlider}
                        />
                    </div>

                    {/* Logout */}
                    <div style={styles.dropdownItem} onClick={handleLogout}>
                        <img src="/assets/icons/locker.png" alt="Logout" style={styles.logoutIcon} />
                        {t.logout}
                    </div>

                    {/* Hidden Therapist Link */}
                    <div
                        style={{ ...styles.dropdownItem, borderTop: 'none', opacity: 0.2, fontSize: '12px' }}
                        onClick={() => navigate('/therapist/login')}
                    >
                        Area Riservata
                    </div>
                </div>
            )}
            {confirmHomeOpen && (
                <div style={styles.modalOverlay}>
                    <div style={styles.modalContent}>
                        <p>{t.confirmExitText}</p>
                        <div style={styles.modalButtons}>
                            <button
                                style={styles.modalButtonConfirm}
                                onClick={confirmHomeYes}
                            >
                                {t.confirmExitYes}
                            </button>
                            <button
                                style={styles.modalButtonCancel}
                                onClick={confirmHomeNo}
                            >
                                {t.confirmExitNo}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </header>
    );
}

const styles = {
    header: {
        color: 'white',
        padding: '30px 40px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '28px',
        zIndex: 999,
        position: 'relative',
    },
    modalButtonConfirm: {
        backgroundColor: '#43a047', // green
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        padding: '10px 24px',
        fontSize: '16px',
        fontFamily: "'Autour One', cursive",
        fontWeight: 'bold',
        cursor: 'pointer',
        marginRight: '8px',
        transition: 'background 0.2s',
    },
    modalButtonCancel: {
        backgroundColor: '#b92227', // gray/red
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        padding: '10px 24px',
        fontSize: '16px',
        fontFamily: "'Autour One', cursive",
        fontWeight: 'bold',
        cursor: 'pointer',
        marginLeft: '8px',
        transition: 'background 0.2s',
    },
    icon: {
        width: '40px',
        height: '40px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    img: {
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
    },
        title: {
            fontFamily: "'Autour One', cursive",
            whiteSpace: 'nowrap',         // Impedisce categoricamente di andare su due righe
            fontSize: 'clamp(14px, 4.5vw, 28px)', // Font fluido: min 14px, max 28px, si adatta allo schermo
            padding: '0 15px',            // Aggiunge spazio laterale per staccarsi dalle icone
            textAlign: 'center',          // Centra il testo
            flex: 1,                      // Prende tutto lo spazio centrale disponibile
            overflow: 'hidden',           // Sicurezza: se lo schermo è microscopico...
            textOverflow: 'ellipsis'      // ...aggiunge i puntini di sospensione invece di sfasare il layout
        },
    
    dropdown: {
        position: 'absolute',
        top: '100%',
        right: '20px',
        backgroundColor: '#fff',
        color: '#333',
        border: '1px solid #ccc',
        borderRadius: '8px',
        marginTop: '10px',
        zIndex: 3,
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
        padding: '10px 0',
        minWidth: '220px',
    },
    dropdownItem: {
        padding: '10px 20px',
        cursor: 'pointer',
        fontSize: '18px',
        fontFamily: "'Autour One', cursive",
        whiteSpace: 'nowrap',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        borderTop: '1px solid #eee',
    },
    logoutIcon: {
        width: '35px',
        height: '35px',
        objectFit: 'contain',
    },
    toggleContainer: {
        padding: '15px 20px',
        borderBottom: '1px solid #eee',
    },
    toggleLabel: {
        fontSize: '14px',
        fontFamily: "'Autour One', cursive",
        marginBottom: '8px',
        display: 'block',
        color: '#666',
    },
    toggleSwitch: {
        position: 'relative',
        width: '180px',
        height: '45px',
        backgroundColor: '#e0e0e0',
        borderRadius: '20px',
        cursor: 'pointer',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
    },
    toggleSlider: {
        position: 'absolute',
        top: '2px',
        left: '2px',
        width: '50%',
        height: '40px',
        borderRadius: '18px',
        transition: 'transform 0.3s ease',
        zIndex: 1,
    },
    toggleOption: {
        position: 'relative',
        width: '50%',
        textAlign: 'center',
        fontSize: '12px',
        fontFamily: "'Autour One', cursive",
        fontWeight: 'bold',
        zIndex: 2,
        transition: 'color 0.3s ease',
        padding: '5%'
    },
    toggleLeft: {
    },
    toggleRight: {
    },
    languageContainer: {
        padding: '15px 20px',
        borderBottom: '1px solid #eee',
        position: 'relative',
    },
    volumeContainer: {
        padding: '15px 20px',
        borderBottom: '1px solid #eee',
    },
    volumeSlider: {
        width: '100%',
        cursor: 'pointer',
    },
    languageSelector: {
        position: 'relative',
        cursor: 'pointer',
    },
    selectedLanguage: {
        display: 'flex',
        alignItems: 'center',
        padding: '8px 12px',
        backgroundColor: '#f8f9fa',
        borderRadius: '6px',
        border: '1px solid #e0e0e0',
        fontSize: '14px',
        fontFamily: "'Autour One', cursive",
    },
    flag: {
        fontSize: '18px',
        marginRight: '8px',
    },
    languageName: {
        flex: 1,
        color: '#333',
    },
    arrow: {
        fontSize: '12px',
        color: '#666',
        transition: 'transform 0.2s ease',
        marginLeft: '8px',
    },
    languageDropdown: {
        position: 'absolute',
        top: '100%',
        left: '0',
        right: '0',
        backgroundColor: '#fff',
        border: '1px solid #e0e0e0',
        borderRadius: '6px',
        marginTop: '2px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        zIndex: 10,
        maxHeight: '200px',
        overflowY: 'auto',
    },
    languageOption: {
        display: 'flex',
        alignItems: 'center',
        padding: '10px 12px',
        cursor: 'pointer',
        fontSize: '14px',
        fontFamily: "'Autour One', cursive",
        transition: 'background-color 0.2s ease',
        borderBottom: '1px solid #f0f0f0',
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
    },
    modalContent: {
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        textAlign: 'center',
        maxWidth: '300px',
        width: '80%',
        fontFamily: "'Autour One', cursive",
        fontSize: '18px',
        color: '#333',
    },
    modalButtons: {
        marginTop: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px', // Small horizontal gap for readability
    },
};
